import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import AuthenticatedApp from "./AuthenticatedApp";
import { msalInstance } from "./authConfig";

async function bootstrap() {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthenticatedApp />
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap();
